import { Component, Input } from '@angular/core';
import { getStatusBadgeStyle } from 'src/app/const/entity-view-constants';
import { EntityStatus, ItemStatus } from 'src/app/interfaces/views.interface';

@Component({
  selector: 'app-breadcrumb-navigation',
  templateUrl: './breadcrumb-navigation.component.html',
  styleUrls: ['./breadcrumb-navigation.component.scss'],
})
export class BreadcrumbNavigationComponent {
  @Input({ required: true }) public link: string;
  @Input({ required: true }) public dataTestId: string;
  @Input({ required: true }) public pageToNavigateTitle: string;
  @Input({ required: true }) public pageTitle: string;

  @Input({ required: false }) public titleDataTestId = 'page-title';
  @Input({ required: false }) public status: EntityStatus = ItemStatus.EMPTY;
  @Input({ required: false }) public showPreviousPage = true;

  public getBadgeStyle(): string {
    return getStatusBadgeStyle(this.status);
  }
}
